const G = "#b8960c";

function DarkTag({ children }) {
  return <span className="inline-block px-2 py-0.5 text-[11px] border border-white/10 text-gray-400 bg-white/5 rounded-sm mr-1 mt-1 hover:text-yellow-500 transition-all cursor-default">{children}</span>;
}

function SectionHeader({ label, title }) {
  return (
    <div className="mb-4">
      <p className="text-xs tracking-[0.25em] uppercase mb-1 font-semibold" style={{ color: G }}>{label}</p>
      <h2 style={{ fontFamily: 'Playfair Display, serif' }} className="text-3xl sm:text-4xl font-black text-white">{title}</h2>
      <div className="w-10 h-0.5 mt-2" style={{ background: G }} />
    </div>
  );
}

export default function GitHub({ refs }) {
  return (
    <section id="GitHub" ref={el => (refs.current["GitHub"] = el)} className="py-8">
      <SectionHeader label="Code" title="GitHub" />
      <div className="border border-white/8 rounded-sm p-5 w-full max-w-lg mb-5" style={{ background: "#1a1a1a" }}>
        <div className="flex items-center gap-4 mb-4">
          <div className="w-11 h-11 rounded-full flex items-center justify-center text-xl border border-white/10 flex-shrink-0" style={{ background: "#2a2a2a" }}>👾</div>
          <div>
            <div style={{ fontFamily: 'Playfair Display, serif' }} className="text-white font-bold">@xcoin-wilson</div>
            <div className="text-xs text-gray-500">Scripts, automation & IT tooling</div>
          </div>
        </div>
        <p className="text-xs text-gray-500 leading-relaxed mb-4">Repositories focused on IT automation scripts, infrastructure tooling and utilities built with Python, PowerShell and Bash.</p>
        <a href="https://github.com/xcoin-wilson?tab=repositories" target="_blank" rel="noreferrer"
          className="inline-block w-full sm:w-auto text-center px-5 py-2.5 text-xs font-bold tracking-widest uppercase rounded-sm transition-all duration-300"
          style={{ background: G, color: "#0f0f0f" }}>
          View Profile →
        </a>
      </div>
      <div className="flex flex-wrap gap-1">
        {["C/C++", "Ruby", "SQL", "JavaScript"].map(l => <DarkTag key={l}>{l}</DarkTag>)}
      </div>
    </section>
  );
}